// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixTableHeadSA-th th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n.language-table-wrap .table td, .table th{\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n}\n.language-term-text {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 700px;\n  cursor: pointer;\n}\n.language-key-col {\n  width: 20%;\n}\n.language-action-col {\n  width: 10%;\n}", ""]);
// Exports
module.exports = exports;
